import React from 'react'
import { Route, Switch } from 'react-router-dom'
import PublicRouteUI from './PublicRouteUI'
import FinAppRouteUI from './FinAppRouteUI'
import ProjectRouteUI from './ProjectRouteUI'
import SuperUserRouteUI from './SuperUserRouteUI'
import HomePageSF from '../pages/public/HomePageSF'
import SettingsRouteUI from './SettingsRouteUI'
import NachClientResponsePageSF from '../pages/public/NachClientResponsePageSF'

const AllRouteUI = ({ context }) =>
  <Switch>
    <Route exact path='/client/nach/response/:key/:hash'
      render={() =>
        <NachClientResponsePageSF context={context} />
      }
    />

    <Route exact path='/'
      render={() =>
        <HomePageSF context={context} />
      }
    />

    <Route exact path='/pub/*'
      render={() =>
        <PublicRouteUI context={context} />
      }
    />

    <Route exact path='/home*'
      render={() =>
        <FinAppRouteUI context={context} />
      }
    />
    <Route exact path='/support/*'
      render={() =>
        <FinAppRouteUI context={context} />
      }
    />

    <Route exact path='/logs*'
      render={() =>
        <FinAppRouteUI context={context} />
      }
    />

    <Route exact path='/reports*'
      render={() =>
        <FinAppRouteUI context={context} />
      }
    />

    <Route exact path='/alerts*'
      render={() =>
        <FinAppRouteUI context={context} />
      }
    />

    <Route exact path='/budgets*'
      render={() =>
        <FinAppRouteUI context={context} />
      }
    />

    <Route exact path='/loans*'
      render={() =>
        <FinAppRouteUI context={context} />
      }
    />

    <Route exact path='/invoices*'
      render={() =>
        <FinAppRouteUI context={context} />
      }
    />

    <Route exact path='/kyc*'
      render={() =>
        <FinAppRouteUI context={context} />
      }
    />

    <Route exact path='/orders*'
      render={() =>
        <FinAppRouteUI context={context} />
      }
    />

    <Route exact path='/txns*'
      render={() =>
        <FinAppRouteUI context={context} />
      }
    />

    <Route exact path='/vendor*'
      render={() =>
        <FinAppRouteUI context={context} />
      }
    />

    <Route exact path='/customer*'
      render={() =>
        <FinAppRouteUI context={context} />
      }
    />

    <Route exact path='/projects*'
      render={() =>
        <FinAppRouteUI context={context} />
      }
    />

    <Route exact path='/projects*'
      render={() =>
        <ProjectRouteUI context={context} />
      }
    />

    <Route exact path='/tasks/*'
      render={() =>
        <ProjectRouteUI context={context} />
      }
    />

    <Route exact path='/settings*'
      render={() =>
        <SettingsRouteUI context={context} />
      }
    />

    <Route exact path='/su*'
      render={() =>
        <SuperUserRouteUI context={context} />
      }
    />

  </Switch>

export default AllRouteUI
